import React, { useState } from 'react'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import { useAppSelector } from '../../../store/hooks'
import { selectCrossClientAvailableNextStepCounts, selectCrossClientSelectedResultIds } from '../../../store/crossClient/crossClientResults'
import { Button } from '../../../components/Button/Button'
import { pluralize } from '../utils'
import { useCrossClientEvaluationActions } from './useCrossClientEvaluationActions'
import { CrossClientQuickActionPopover } from './CrossClientQuickActionPopover'
import './CrossClientQuickActionBar.scss'

export const CrossClientQuickActionBar: React.FC = () => {
  const selectedIds = useAppSelector(selectCrossClientSelectedResultIds)
  const { localNext, aiNext } = useAppSelector(selectCrossClientAvailableNextStepCounts)
  const { evaluateSelectionSplit } = useCrossClientEvaluationActions()

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [open, setOpen] = useState(false)

  const hasSelection = selectedIds.length > 0
  const outstanding = localNext + aiNext

  if (!hasSelection && outstanding === 0) {
    return null
  }

  const sentence = hasSelection
    ? `Continue analysis for ${selectedIds.length.toLocaleString()} selected ${pluralize(selectedIds.length, 'client')}`
    : `Continue analysis for ${outstanding.toLocaleString()} ${pluralize(outstanding, 'client')}`

  const handleSelectionClick = async () => {
    if (isSubmitting) {
      return
    }
    setIsSubmitting(true)
    try {
      await evaluateSelectionSplit(selectedIds)
    } finally {
      setIsSubmitting(false)
    }
  }

  const popover = (
    <Popover id='cross-client-quick-action-popover' className='cross-client-quick-action-popover'>
      <Popover.Body>
        <CrossClientQuickActionPopover onClose={() => setOpen(false)} />
      </Popover.Body>
    </Popover>
  )

  return (
    <div className='cross-client-quick-action-bar d-flex align-items-center justify-content-between gap-4'>
      <div className='d-flex align-items-center gap-3'>
        <div className='cross-client-quick-action-bar__icon d-flex align-items-center justify-content-center'>
          <i className='bi bi-lightning' aria-hidden='true' />
        </div>
        <div className='d-flex flex-column'>
          <span className='cross-client-quick-action-bar__label zocks-text-gray-600'>QUICK ACTION</span>
          <span className='paragraph-small fw-bold zocks-text-gray-900'>{sentence}</span>
        </div>
      </div>
      {hasSelection ? (
        <Button variant='primary' className='button-medium rounded-3 text-nowrap' onClick={() => void handleSelectionClick()} loading={isSubmitting}>
          Continue
        </Button>
      ) : (
        <OverlayTrigger trigger='click' rootClose placement='top-end' show={open} onToggle={setOpen} overlay={popover}>
          <Button variant='primary' className='button-medium rounded-3 text-nowrap d-inline-flex align-items-center gap-2'>
            Continue
            <i className='bi bi-chevron-expand' aria-hidden='true' />
          </Button>
        </OverlayTrigger>
      )}
    </div>
  )
}
